/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Similar_LabelInputs */

const en_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Similar Reads`)
};

const ar_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قراءات مشابهة`)
};

const bn_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পর্কিত লেখা`)
};

const de_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ähnliche Beiträge`)
};

const es_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturas similares`)
};

const fr_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lectures similaires`)
};

const pt_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leituras semelhantes`)
};

const zh_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类似读物`)
};

const tr_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzer Okumalar`)
};

const ru_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Похожие чтения`)
};

const pl_note_similar_label = /** @type {(inputs: Note_Similar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podobne odczyty`)
};

/**
* | output |
* | --- |
* | "Similar Reads" |
*
* @param {Note_Similar_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const note_similar_label = /** @type {((inputs?: Note_Similar_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Similar_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_note_similar_label(inputs)
	if (locale === "bn") return bn_note_similar_label(inputs)
	if (locale === "de") return de_note_similar_label(inputs)
	if (locale === "es") return es_note_similar_label(inputs)
	if (locale === "fr") return fr_note_similar_label(inputs)
	if (locale === "pt") return pt_note_similar_label(inputs)
	if (locale === "zh") return zh_note_similar_label(inputs)
	if (locale === "tr") return tr_note_similar_label(inputs)
	if (locale === "ru") return ru_note_similar_label(inputs)
	if (locale === "pl") return pl_note_similar_label(inputs)
	return en_note_similar_label(inputs)
});